angular.module('login.social', [
  'login.social.google',
  'login.social.facebook',
  'login.social.twitter'
]);



// WEBPACK FOOTER //
// ./client/src/app/login/social/index.js